 import React from 'react';
import { BsRadar  } from 'react-icons/bs';

 export default function SpyRadarIco({ className = '', ...props }) {
  return (
    <span
      className={`absolute inline-flex  items-center rounded-full bg-white px-2.5 py-1.5 text-[10px] font-semibold shadow-sm ring-1 ring-black/10 ${className}`}
      {...props}
    >

      <span className="font-bold text-black ">Spy</span>
      <span className="font-bold text-primary-500">Radar</span>
    </span>
  
  );
}
